// extracted by mini-css-extract-plugin
module.exports = {"main":"Shop_main__3vG1Q"};